@if (onboardingData()) {
    <bs-reward-tokens-onboarding [viewState]="onboardingData()" (dismiss)="hideOnboarding()"></bs-reward-tokens-onboarding>
}
